import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import TodoBoard from './TodoBoard';
import { ENABLE_MODAL_SWIPE_BACK } from '../utils/mobileModalSwipe';

export default function TodoMobile({ open, onClose }) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!ENABLE_MODAL_SWIPE_BACK) {
      touchStartX.current = null;
      touchEndX.current = null;
      return;
    }
    if (!touchStartX.current || !touchEndX.current) return;

    if (touchStartX.current - touchEndX.current > 50) {
      onClose();
    }

    touchStartX.current = null;
    touchEndX.current = null;
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 100004,
        display: 'flex',
        background: 'rgba(18, 8, 28, 0.88)',
      }}
      {...(ENABLE_MODAL_SWIPE_BACK ? { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd } : {})}
    >
      <TodoBoard onClose={onClose} isMobile />
    </div>,
    document.body
  );
}
